import { useQuery } from "@tanstack/react-query";
import { getBranches } from "api/branch.api";
import { QUERY_KEYS } from "config/queryKeys";

export const useGetBranches = (params = {}) => {
  return useQuery({
    queryKey: QUERY_KEYS.branches.list(params),
    queryFn: () => getBranches(params),
    select: (data) =>
      data?.data?.branches || data?.branches || data?.data || [],
    staleTime: 1000 * 60 * 30,
  });
};
